import ProductSearchInput from "@/pages/Plan/BottomUp/components/ProductSearchInput";

interface Props {
  searchQuery: string;
  onSearchChange: (q: string) => void;
  // Dropdowns after the search box.
  children?: React.ReactNode;
  // Pinned to the right end (By Channel's Today and arrows).
  trailing?: React.ReactNode;
}

// The flat bar above both Inventory grids: one strip on the page background,
// so it reads as one band with the title, with a bottom border. Search first,
// then the filters, every control 32px tall.
export default function InventoryToolbar({ searchQuery, onSearchChange, children, trailing }: Props) {
  return (
    <div className="flex flex-shrink-0 flex-wrap items-center gap-2 border-b border-border bg-page-background px-3 py-1.5">
      <ProductSearchInput
        value={searchQuery}
        onChange={onSearchChange}
        className="h-8 w-60 flex-none"
      />
      {children}
      {trailing && <div className="ml-auto flex items-center gap-1">{trailing}</div>}
    </div>
  );
}
